import React from 'react';

function ReturnToHome({ apiOutput }) {
    return (<div className="col-md-12 text-align-center pad-1 nav-link">
        <a className="btn margin-auto-lr" href={apiOutput?.redirectionUrl}>
            Return to Homepage
        </a>
    </div>);
}
export default ReturnToHome;